import { PaginationRequest } from 'models/common/Pagination';
import { Crud } from '../common/Edit';
import { Code } from '../common/CommonCode';
import { MpResult } from './MpResult';
import { MpDrwList } from './MpDrw';

export enum ItemStatCd {
  Regist = 'MP001', // Item 등록
  Develop = 'MP002', // 개발중
  CopReview = 'MP003', // 법인검토중
  M4Change = 'MP004', // 4M 변경중
  McrcReview = 'MP005', // 분과위 심의중 (개발완료)
  HeComplete = 'MP006', // 수평전개 완료
  HeHold = 'MP007', // 수평전개 보류
  Drop = 'MP010', // Drop
  Complete = 'MP011', // 완료
}

export enum TapButtonType {
  ButtonSave = 'SAVE', // 저장
  ButtonIprvClsfChange = 'IPRV_CLSF_CHANGE', // 개선목적변경
  ButtonReviewComplete = 'REVIEW_COMPLETE', // 심의완료
  ButtonHeReprocess = 'HE_REPROCESS', // 수평전개 재진행
  ButtonItemRegist = 'MP001', // Item 등록
  ButtonDev = 'MP002', // 개발중
  ButtonM4Change = 'MP004', // 4M 변경중
  ButtonDevComp = 'MP005', // 분과위 심의중 (개발완료)
  ButtonDrop = 'MP010', // 드랍
  // 수평전개
  ButtonCopSet = 'CORP_SET', // 법인설정
  ButtonEcConv = 'EC_CONV', // EC 전환
  ButtonRvwComp = 'MP003', // 검토완료
  ButtonHeComp = 'HE_COMP', // 수평전개 완료 (임시 상태변경 버튼 - IF 개발완료 후 삭제 예정)
  ButtonComp = 'COMP', // 완료 (임시 상태변경 버튼 - IF 개발완료 후 삭제 예정)
  ButtonM4Comp = 'ButtonM4Comp', // 4MCC 완료 (4M변경중 노출)(임시 상태변경 버튼 - IF 개발완료 후 삭제 예정)
  ButtonM4Drop = 'ButtonM4Drop', // 드랍 (4M변경중 노출)(임시 상태변경 버튼 - IF 개발완료 후 삭제 예정)
}

export enum MpItemTpCho {
  MP = 'MP', // 설비변경점
  HE = 'HE', // 수평전개
  MPHE = 'MPHE', // 설비변경점/수평전개
  NI = 'NI', // 신규개선
}

export enum MpItemTpCd {
  MP = 'MP', // 설비변경점
  HE = 'HE', // 수평전개
  MPHE = 'MPHE', // 설비변경점/수평전개
  NI = 'NI', // 신규개선
  SPSH = 'SPSH', // 제작사양서
}

export enum MpItemAtchFileTpCd {
  MP_ITEM = 'MP_ITEM', // 첨부파일
  MP_MINUTES = 'MP_MINUTES', // 회의록
  SPEC_SHEET = 'SPEC_SHEET', // 표준사양서
  MP_ITEM_RPT = 'MP_ITEM_RPT', // 개조/개선 Item 보고서
  VAID_EVL_RPT = 'VAID_EVL_RPT', // 유효성 평가 보고서
  SCMM_MINT = 'SCMM_MINT', // 회의록(설비변경 심의)
  MP_FSTR = 'MP_FSTR', // Fast Track 근거자료
  MP_HE_RPT = 'MP_HE_RPT', // 회의록(수평전개 심의)
}

export const ecoYNcodes: Code[] = [
  { cmnCd: 'Y', cmnCdNm: 'EC' },
  { cmnCd: 'N', cmnCdNm: 'NC' },
];

export interface MpItemRequestCondition extends PaginationRequest {
  aprReqId?: string;
}

export interface MpItemApprovalRequest extends PaginationRequest {
  xlsUploadId?: string;
  aprReqId?: string;
  aprTplId?: string;
  aprPvnDdlnCd?: string;
  aprReqTitNm?: string;
  trnmBdyCtn?: string;
  mode?: string;

  reqSeqId?: string;
  reqType?: string;
  mpReqList?: MpItem[];
}

export interface MpItemBookmarkRequest extends PaginationRequest {
  bmkGrId?: string;
  mpItems?: MpItem[];
}

export interface MpItemCopyRequest extends PaginationRequest {
  mpItems?: MpItem[];
}

export interface MpItemCondition extends PaginationRequest {
  itemId?: string; // 품목ID
  copCd?: string; // 법인코드
  copCds?: any; // 법인코드 멀티셀렉트
  mpClsfCd?: string; // MP분류코드 (tb_elm_mp_item_tp_n)
  mpClsfCds?: any; // MP분류코드 멀티셀렉트
  procCd?: string; // 공정코드
  procCds?: any; // 공정코드 멀티셀렉트
  eqclId?: string; // 설비군
  eqpId?: string; // 설비ID
  eqpClsfNo?: string; // 설비분류번호
  itemNm?: string; // 품목명
  mpItemTpCd?: string; // 품목유형코드
  itemStatCd?: string; // item 상태
  iprvClsfLv1Cd?: string; // 개선분류1레벨코드
  iprvClsfLv2Cd?: string; // 개선분류2레벨코드
  iprvClsfLv3Cd?: string; // 개선분류3레벨코드
  ecoYn?: string; // ECO여부 (Y: EC, N: NC)
  fstrYn?: string; // 패스트트랙여부
  m4ChgNo?: string; // 4M변경번호
  wkDivsCd?: string; // 작업구분코드
  reqMgrId?: string; // 기술제안자
  startDataInsDtm?: string; // 등록일 검색시작일
  endDataInsDtm?: string; // 등록일 검색종료일
  bmkGrId?: string; // 즐겨찾기그룹ID
  eqpLv1Cd?: string; // 설비1레벨코드
  eqpLv2Cd?: string; // 설비2레벨코드
  eqpLv3Cd?: string; // 설비3레벨코드
  dataInsUserId?: string; // 데이터입력사용자ID
  heYn?: string; // 수평전개여부 (Y: 진행, N: 보류)
  spshRevCtn?: string; // 제작사양서 진행상태
}

export interface MpItem extends Crud {
  itemId?: string; // 품목ID
  itemNm?: string; // 품목명
  itemEngNm?: string; // 품목영어명
  itemCngNm?: string; // 품목중국어명
  procCd?: string; // 공정코드
  eqclId?: string; // 설비군
  eqpClsfNo?: string; // 설비분류번호 (x)
  eqpLv1Cd?: string; // 설비1레벨코드 (x)
  eqpLv2Cd?: string; // 설비2레벨코드 (x)
  eqpLv3Cd?: string; // 설비3레벨코드 (x)
  eqpLv4Cd?: string; // 설비4레벨코드 (x)
  eqpLv1Nm?: string; // 설비1레벨명 (x)
  eqpLv2Nm?: string; // 설비2레벨명 (x)
  eqpLv3Nm?: string; // 설비3레벨명 (x)
  eqpLv4Nm?: string; // 설비4레벨명 (x)
  wkDivsCd?: string; // 작업구분코드 (x)
  iprvClsfLv1Cd?: string; // 개선분류1레벨코드
  iprvClsfLv1CdNm?: string;
  iprvClsfLv2Cd?: string; // 개선분류2레벨코드
  iprvClsfLv2CdNm?: string;
  iprvClsfLv3Cd?: string; // 개선분류3레벨코드
  iprvClsfLv3CdNm?: string;
  mpItemTpCd?: string; // MP품목유형코드
  mpItemTpCdNm?: string; // MP품목유형코드명
  ecoYn?: string; // ECO여부 (Y: EC, N: NC)
  fstrYn?: string; // 패스트트랙여부
  rawSysNm?: string; // 원천시스템명
  oldRevCtn?: string; // 변경전개정내용
  newRevCtn?: string; // 변경후개정내용
  m4ChgNo?: string; // 4M변경번호
  m4StatCd?: string; // 4M상태코드
  m4StatNm?: string; // 4M상태코드명
  m4LvNm?: string; // 4M레벨명
  itemStatCd?: string; // 품목상태코드
  itemStatCdNm?: string;
  reqMgrId?: string; // 요청담당자ID
  reqMgrNm?: string; // 요청담당자명
  chgCrgeUserId?: string; // 변경담당자사용자ID
  chgCrgeUserNm?: string; // 변경담당자사용자명
  itemTpChoCd?: string; // 품목유형선택코드 (x)
  heYn?: string; // 수평전개여부
  mpYn?: string; // MP여부 (x)
  niYn?: string; // 신규개선여부 (x)
  duplYn?: string; // 중복여부 (x)
  m4ChgYn?: string; // M4변경여부 (x)
  spshRvwYn?: string; // 사양서검토여부
  spshRevCtn?: string; // 제작사양서 개정상태
  spshRevCtnNm?: string; // 제작사양서 개정상태명
  isuDesc?: string; // 이슈설명 (x)
  causCtn?: string; // 원인내용 (x)
  causTactCtn?: string; // 원조치내용 (x)
  iprvCtn?: string; // 개선내용 (x)
  rmk?: string; // 비고
  atchFileGrId?: string; // 첨부파일그룹ID
  useYn?: string; // 사용여부
  optValCtn1?: string; // 옵션값내용1
  optValCtn2?: string; // 옵션값내용2
  optValCtn3?: string; // 옵션값내용3
  optValCtn4?: string; // 옵션값내용4
  optValCtn5?: string; // 옵션값내용5
  dataInsUserId?: string; // 데이터입력사용자ID
  dataInsUserNm?: string;
  dataInsDtm?: string; // 데이터입력일시
  dataUpdUserId?: string; // 데이터수정사용자ID
  dataUpdUserNm?: string;
  dataUpdDtm?: string; // 데이터수정일시
  mpClsfCd?: string; // MP분류코드
  mpClsfCdNm?: string; // MP분류코드명
  mpClsfCds?: string; // MP분류코드목록 (tb_elm_mp_item_tp_n) (x)
  copCdNm?: string; // 법인코드명 (ex. LGESGM, LGESHD, ...) (x)
  atchFileCnt?: number; // 첨부파일수
  specSheetAtchFileCnt?: number; // 표준사양서 첨부파일수
  mpItemRptAtchFileCnt?: number; // 개조/개선 Item 보고서 첨부파일수
  vaidEvlRptAtchFileCnt?: number; // 유효성 평가보고서 첨부파일수
  scmmMintAtchFileCnt?: number; // 회의록(설비변경 심의) 첨부파일수
  mpFstrAtchFileCnt?: number; // Fast Tracck 근거자료 첨부파일수
  mpHeRptAtchFileCnt?: number; // 회의록(수평전개 심의) 첨부파일수
  resultList?: MpResult[]; // 결과정보 목록 (설비목록)
  eqpChgRsnCtn?: string; // 설비변경사유
  itemTpCd?: string; // 품목유형코드 (ex. MP, HE, NI) (x)
  tgtCopCd?: string; // 대상법인코드
  tgtPlntCd?: string; // 대상공장코드
  tgtPlntCdNm?: string; // 대상공장코드명
  itemTpCdNm?: string; //mp유형명 (x)
  occrEvtNm?: string; //발생이벤트명 (x)
  mcrcYn?: string; // 분과위여부
  reqMgrYn?: string; // 담당자여부
  reqMgrChgRsnCtn?: string; // 담당자변경사유
  drwMgrChgRsnCtn?: string; // 사양서담당자변경사유
  eqpIds?: string; // 대상설비ID
  eqpNms?: string; // 대상설비명 (노출용)
  mcrcIds?: string; // 분과위사용자ID
  mcrcNms?: string; // 분과위사용자명
  mpDrwList?: MpDrwList[]; // 제작사양서정보 목록
  drwId?: string; // 도면ID
  drwNm?: string; // 도면명
  drwNms?: string; // 도면명
  drwChgProgStatCd?: string; // 도면 변경진행상태코드
  drwChgProgStatCdNm?: string; // 도면 변경진행상태코드명
  totalCount?: string; //진척률 전체
  doneCount?: string; //진척률 완료
  chgHisId?: string; // 상태변경이력ID
  bmkYn?: string; // 관심항목여부
}

export interface MpResultN extends MpItem {
  execPlanId?: string;
  itemId?: string;
  itemTpCd?: string;
  copCd?: string;
  plntCd?: string;
  lnId?: string;
  eqpId?: string;
  tgtYn?: string;
  planDtm?: string;
  cpltDtm?: string;
  wkProgCtn?: string;
  rmk?: string;
  atchFileGrId?: string;
  useYn?: string;
  optValCtn1?: string;
  optValCtn2?: string;
  optValCtn3?: string;
  optValCtn4?: string;
  optValCtn5?: string;
}
